import "jquery";
import _ from "lodash";
import "./special_news.scss";
import "bootstrap";
import "popper.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";
import sponsors from "../sponsors";
import "../coffee.main.scss";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "LNBP Contigo";
const category_id = 237;

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

// //selected news
let selected_news_container = document.createElement("div");
selected_news_container.id = "js__selected_news_container";
selected_news_container.style.display = "none";
page_template_content.appendChild(selected_news_container);

var url = new URL(window.location.href);
var news_id = url.searchParams.get("news_id");
if (news_id != null && news_id != undefined) {
  displaySelectedNews(news_id);
} else {
  //page_news
  page_template_content.appendChild(displayNews());
}

//small banner
page_template_content.appendChild(displayTopBanner(33));

//news list
page_template_content.appendChild(displayNewsList());

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/

/* Banner */
function displayNewsType1(news, div_element) {
  let container = document.createElement("div");
  container.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      displaySelectedNews(news.id);
    },
    true
  );

  let img = document.createElement("img");
  img.src = base_url + news.full_url_image;

  let title = document.createElement("span");
  title.innerHTML = news.name;

  container.appendChild(img);
  container.appendChild(title);
  div_element.appendChild(container);
}

function displayNewsType2(news, div_element) {
  let container = document.createElement("div");
  container.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      displaySelectedNews(news.id);
    },
    true
  );

  let img = document.createElement("img");
  img.src = base_url + news.full_url_image;

  let title = document.createElement("span");
  title.innerHTML = news.name.slice(0, 30) + "...";
  title.classList.add("news_type_2_title");

  let line = document.createElement("hr");

  let description = document.createElement("span");
  description.textContent =
    news.description.replace(/<\/?[^>]+(>|$)/g, " ").slice(0, 60) + "...";

  let date = document.createElement("span");
  date.innerHTML = news.created_at.slice(0, 10);
  date.classList.add("news_type_2_date");

  container.appendChild(img);
  container.appendChild(title);
  container.appendChild(line);
  container.appendChild(description);
  container.appendChild(date);

  div_element.appendChild(container);
}

function displayNewsType3(news, div_element) {
  let row = document.createElement("div");
  row.classList.add("row");
  row.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      displaySelectedNews(news.id);
    },
    true
  );

  let row_col_1 = document.createElement("div");
  row_col_1.classList.add("col-sm-6", "col-lg-6", "col-md-6");
  let row_col_2 = document.createElement("div");
  row_col_2.classList.add("col-sm-6", "col-lg-6", "col-md-6");

  row.appendChild(row_col_1);
  row.appendChild(row_col_2);

  let img = document.createElement("img");
  img.src = base_url + news.full_url_image;

  let title = document.createElement("span");
  title.innerHTML = news.name.slice(0, 30) + "...";
  title.classList.add("news_type_3_title");

  let line = document.createElement("hr");

  let description = document.createElement("span");
  description.textContent =
    news.description.replace(/<\/?[^>]+(>|$)/g, " ").slice(0, 60) + "...";

  let date = document.createElement("span");
  date.innerHTML = news.created_at.slice(0, 10);
  date.classList.add("news_type_3_date");

  row_col_1.appendChild(img);
  row_col_2.appendChild(title);
  row_col_2.appendChild(line);
  row_col_2.appendChild(description);
  row_col_2.appendChild(date);

  div_element.appendChild(row);
}

function displayNews() {
  let container = document.createElement("div");
  container.id = "js__news_widget_container";

  let row_1 = document.createElement("div");
  row_1.classList.add("row");

  let row_1_col_1 = document.createElement("div");
  row_1_col_1.classList.add("col-sm-12", "col-md-6", "col-lg-6", "news_type_1");

  let row_1_col_2 = document.createElement("div");
  row_1_col_2.classList.add("col-sm-6", "col-md-3", "col-lg-3", "news_type_2");

  let row_1_col_3 = document.createElement("div");
  row_1_col_3.classList.add("col-sm-6", "col-md-3", "col-lg-3", "news_type_2");

  row_1.appendChild(row_1_col_1);
  row_1.appendChild(row_1_col_2);
  row_1.appendChild(row_1_col_3);

  let row_2 = document.createElement("div");
  row_2.classList.add("row");

  let row_2_col_1 = document.createElement("div");
  row_2_col_1.classList.add("col-sm-12", "col-md-3", "col-lg-3", "news_type_2");

  let row_2_col_2 = document.createElement("div");
  row_2_col_2.classList.add("col-sm-6", "col-md-3", "col-lg-3", "news_type_2");

  let row_2_col_3 = document.createElement("div");
  row_2_col_3.classList.add("col-sm-6", "col-md-6", "col-lg-6", "news_type_1");

  row_2.appendChild(row_2_col_1);
  row_2.appendChild(row_2_col_2);
  row_2.appendChild(row_2_col_3);

  container.appendChild(row_1);
  container.appendChild(row_2);

  var ajax_data = {
    count: 6,
    id_category: category_id
  };
  $.ajax({
    type: "POST",
    url: base_url + "/communication/news/all",
    data: ajax_data
  }).done(function (response) {
    if (response.items[0]) {
      displayNewsType1(response.items[0], row_1_col_1);
    }
    if (response.items[1]) {
      displayNewsType2(response.items[1], row_1_col_2);
    }
    if (response.items[2]) {
      displayNewsType2(response.items[2], row_1_col_3);
    }
    if (response.items[3]) {
      displayNewsType2(response.items[3], row_2_col_1);
    }
    if (response.items[4]) {
      displayNewsType2(response.items[4], row_2_col_2);
    }
    if (response.items[5]) {
      displayNewsType1(response.items[5], row_2_col_3);
    }
  });

  return container;
}

function displayNewsList() {
  let list = document.createElement("div");
  list.classList.add("row");

  var ajax_data = {
    count: 10,
    id_category: category_id
  };
  $.ajax({
    type: "POST",
    url: base_url + "/communication/news/all",
    data: ajax_data
  }).done(function (response) {
    if (response.items.length > 0) {
      response.items.forEach((news) => {
        let list_col = document.createElement("div");
        ("news_type_2");
        list_col.classList.add(
          "col-sm-12",
          "col-md-6",
          "col-sm-6",
          "news_type_3"
        );
        displayNewsType3(news, list_col);
        list.appendChild(list_col);
      });
    }
  });

  return list;
}

function displaySelectedNews(news_id) {
  let news_widget = document.getElementById("js__news_widget_container");
  if (news_widget != undefined && news_widget != null) {
    news_widget.style.display = "none";
  }

  let news_main_container = document.getElementById(
    "js__selected_news_container"
  );
  news_main_container.innerHTML = "";
  let news_container = document.createElement("div");
  news_container.id = "js__news_selected_news";
  news_container.classList.add("row");

  if (news_id >= 1) {
    var ajax_data = {
      id: news_id
    };

    $.ajax({
      type: "POST",
      url: base_url + "/communication/news/single",
      data: ajax_data
    }).done(function (response) {
      let news_text = document.createElement("p");
      news_text.classList.add("news_text");

      news_container.appendChild(news_text);

      news_text.innerHTML = response.item.text;

      let news_hr = document.createElement("hr");
      news_hr.classList.add("news_title_hr");

      news_text.prepend(news_hr);

      let news_title = document.createElement("h4");
      news_title.textContent = response.item.title;

      news_text.prepend(news_title);

      //this has to be the first element on the paragraph
      let news_img = document.createElement("img");
      news_img.classList.add("news_img");
      news_img.src = base_url + response.item.full_url_image;
      news_text.prepend(news_img);
      news_container.style.display = "";
    });
  } else {
    news_container.style.display = "none";
  }

  news_main_container.appendChild(news_container);
  news_main_container.style.display = "";

  news_main_container.scrollIntoView({ behavior: "smooth" });
}

/* Banner */
function displayTopBanner(id_entry) {
  //Prepare the request data.
  var ajax_data = {
    id: id_entry
  };

  let image_container = document.createElement("div");
  image_container.classList.add("text-center", "banner_center");

  $.ajax({
    type: "POST",
    url: base_url + "/cms/entries/single",
    data: ajax_data
  }).done(function (response) {
    let image = document.createElement("img");
    image.src = base_url + response.item.full_url_image;
    if (
      response.item.full_url_image != null &&
      !response.item.full_url_image.includes("no-image.jpg")
    ) {
      image_container.appendChild(image);
    }
  });

  return image_container;
}
